/**
 * Navigation Constants — Single Source of Truth (SSOT).
 * 
 * Central registry for all navigation links, sidebar tabs, and popup menu items.
 */

import type { IconName } from '../atoms/Icon';

export type SidebarTabId = 'send' | 'receive' | 'all';

export interface SidebarTabItem {
  tab: SidebarTabId;
  icon: IconName;
  label: string;
}

export interface NavLinkItem {
  label: string;
  href: string;
  icon?: IconName;
}

/**
 * TopNavbar & Drawer navigation links across landing pages and web app.
 */
export const SITE_NAV_LINKS: readonly NavLinkItem[] = [
  { label: 'About',        href: '/about/'        },
  { label: 'How it Works', href: '/how-it-works/' },
  { label: 'FAQ',          href: '/faq/'          },
  { label: 'Blog',         href: '/blog/'         },
  { label: 'Alternatives', href: '/alternatives/' },
  { label: 'Privacy',      href: '/privacy/'      },
  { label: 'Terms',        href: '/terms/'        },
] as const;

/**
 * Main sidebar navigation tabs for Send, Receive, and All transfers.
 */
export const SIDEBAR_TABS: readonly SidebarTabItem[] = [
  { tab: 'send',    icon: 'send',      label: 'Send'    },
  { tab: 'receive', icon: 'download',  label: 'Receive' },
  { tab: 'all',     icon: 'transfers', label: 'All'     },
] as const;

/**
 * Sidebar Pages Info popup items.
 */
export const INFO_PAGES_LINKS: readonly (NavLinkItem & { icon: IconName })[] = [
  { icon: 'info',      label: 'About BitDrop',    href: '/about/'        },
  { icon: 'zap',       label: 'How it Works',    href: '/how-it-works/' },
  { icon: 'globe',     label: 'FAQ & Help',      href: '/faq/'          },
  { icon: 'lock',      label: 'Privacy Policy',  href: '/privacy/'      },
  { icon: 'transfers', label: 'Terms of Service', href: '/terms/'        },
] as const;
